// extracted by mini-css-extract-plugin
export default {"imageBack":"styles_imageBack__8wBYm","imageBackMobile":"styles_imageBackMobile__Lhsue","zeroPadding":"styles_zeroPadding__guna4","buttonSend":"styles_buttonSend__cCXwn"};